<div *ngIf="visible" class="alert alert-warning alert-dismissible p-2 m-0" role="alert">
    <!-- Close Button -->
    <button class="close-btn" (click)="closeAlert()" aria-label="Close">&times;</button>
    <div class="row p-0 m-0">
        <div class="col-1 d-flex align-items-center justify-content-center p-0 mr-1">
            <i class="bi bi-exclamation-triangle" style="font-size: 21px; color: #ff9f43;"></i>
        </div>
        <div class="col p-0 m-0">
           <div class="row">
            <div class="col p-0 m-0">
                <strong class="" style="font-size: 16px;">{{ alertData.heading }}</strong>  
            </div>
           </div>
           <div class="row">
            <div class="col p-0 m-0">
                <span style="font-size: 12px;">{{ alertData.message }}</span>
            </div>
           </div>
           <div class="row">
            <div class="col p-0 m-0">
                <a style="font-size: 14px; color: blue; font-weight: bold; text-decoration: underline;" routerLink="/profile/Settings">Click To Publish</a>
            </div>
           </div>
        </div>
    </div>
</div>